module.exports = __webpack_public_path__ + "img/tie-2.35753381.png";